import * as Card from '@/components/ui/card'
import { Heading } from '@/components/ui/heading'
import { PaymentsPortalButton } from '@features/PaymentsPortalButton'
import { useService } from 'solid-services'
import { Text } from 'src/components/ui/text'
import { useSubscription } from 'src/state/subscription'
import { Grid } from 'styled-system/jsx'

export default function CheckoutButton() {
  const { subscription, currentPeriodEnd } = useService(useSubscription)()

  return (
    <Card.Root
      p={4}
      display="grid"
    >
      <Heading>My Subscription</Heading>
      <Grid gridTemplateColumns='1fr auto'>
        <div>
          <Text textStyle='sm'>My current Plan: {subscription.data?.plan}</Text>
          <Text textStyle='sm'>My current Status: {subscription.data?.status}</Text>
          <Text textStyle='sm'>Current period end: {currentPeriodEnd()}</Text>
        </div>
        <PaymentsPortalButton />
      </Grid>
    </Card.Root>
  )
}
